<template>
  <v-container>
    <ReceiptViewer
      v-if="showDialog"
      ref="receiptDetails"
      inspectMode
      v-on:hide="showDialog = false"
      :showDialog="showDialog"
      :receiptImage="receiptImageElement"
      :editMode="false"
    />
    <v-card>
      <v-layout column>
        <v-flex style>
          <v-data-table
            :items="recentReceipts"
            :no-data-text="('Receipts no DataText')"
            :disable-pagination="true"
            :hide-default-footer="true"
            :headers="headers"
            :loading="isLoading"
          >
            <template v-slot:header.receiptId="{ header }">
              <v-text-field v-model="searchReceiptId" label="Receipt ID"></v-text-field>
            </template>
            <template v-slot:header.campaignId="{ header }">
              <v-text-field v-model="searchCampaignId" label="Campaign ID"></v-text-field>
            </template>

            <template slot="item" slot-scope="{ item }">
              <tr @click="setCurrentReceipt(item,item.campaign)">
                <td>{{ item.referenceNumber}}</td>
                <td>{{ formattedDate(item.uploadedAt)}}</td>
                <td>{{ item.campaignId}}</td>

                <td>{{item.status}}</td>
                <td>{{ item.email}}</td>
                <td>{{ item.rejectReason}}</td>
                <!-- <td>{{ item.dashboarder.name }}</td> -->
              </tr>
            </template>

            <template slot="no-data">
              <v-alert
                :value="true"
                icon="mdi-cancel"
                class="display-1 font-weight-thin"
              >No receipts found for now ¯\_(ツ)_/¯</v-alert>
            </template>
            <template slot="footer"></template>
          </v-data-table>
        </v-flex>
        <infinite-loading :identifier="page" @infinite="infiniteHandler">
          <div slot="no-more">No more receipts</div>
          <div slot="no-results">No results</div>
        </infinite-loading>
      </v-layout>
    </v-card>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { mapFields } from "../store/helpers";
import ReceiptViewer from "../components/ReceiptViewer";
import moment from "moment";
import InfiniteLoading from "vue-infinite-loading";

export default {
  components: {
    ReceiptViewer,
    InfiniteLoading
  },
  watch: {
    showDialog(val) {
      console.log("SHoW DiaLOG Watch 2", val);
      if (val === false) {
        this.receiptImageElement = null;
        this.receiptImageIsLoading = true;
        this.img = new Image();
      }
    },
    searchReceiptId(val) {
      this.searchForReceipt(this.infiniteState);
    },
    searchCampaignId(val) {
      this.searchForReceipt(this.infiniteState);
    },
    searchDashboarderId(val) {
      this.searchForReceipt(this.infiniteState);
    }
  },
  data() {
    return {
      img: new Image(),
      receiptImageElement: new Image(),
      receiptImageIsLoading: true,
      isLoading: true,
      searchReceiptId: "",
      searchCampaignId: "",
      searchDashboarderId: "",
      search: "",
      selectedSearch: ["receiptId"],
      searchOptions: [
        { text: "Receipt", value: "receiptId" },
        // { text: "Campaign", value: "campaignId" },
        // { text: "Dashboarder", value: "dashboarderId" }
      ],
      showDialog: false,
      page: 0,
      headers: [
        {
          sortable: false,
          align: "left",
          text: "Receipt ID",
          value: "receiptId"
        },
        {
          sortable: true,
          text: "Uploaded Time",
          value: "id"
        },
        {
          sortable: false,
          text: "Campaign",
          value: "campaignId"
        },
        {
          sortable: false,
          text: "Status",
          value: "campaignTitle"
        },
        {
          sortable: false,
          text: "Dashboarder",
          value: "dashboarderId"
        },
        {
          sortable: false,
          text: "Receipt Date",
          value: "campaignTitle"
        }
      ],
      recentReceipts: []
    };
  },
  computed: {
    ...mapGetters(["userToken", "selectedDashboard"]),
    ...mapFields([
      "reClaimed",
      "reClaimText",
      "referenceNumber",
      "receiptImageURL",
      "createdAt",
      "createdAtDate",
      "createdAtTime",
      "status",
      "id",
      "campaignTitle",
      "campaign_fk",
      "receiptNumber",
      "total",
      "campaignRetailers",
      "hasWallet",
      "products",
      "couponsToCreate",
      "hasEditableCoupons",
      "productImageURL",
      "detailsText",
      "campaignEndDate",
      "campaignStartDate",
      "processedProducts",
      "productTotal",
      "retailerFk",
      "customerToken",
      "selectedProducts",
      "rejectReason",
      "total",
      "receiptId",
      "vatNumber",
      "paymentAmount",
      "receiptDateTime",
      "country",
      "postCode",
      "clubCode",
      "fiscalId",
      "rppData"
    ])
  },
  methods: {
    makePayload() {
      const payload = {
        userToken: this.userToken,
        limit: 30,
        dashboard: this.selectedDashboard
      };

      payload["referenceNumber"] = this.searchReceiptId;
      payload["campaignId"] = this.searchCampaignId;
      payload["userId"] = this.searchDashboarderId;

      return payload;
    },
    searchForReceipt($state) {
      // if(!this.searchReceiptId) return
      this.isLoading = true;
      if (!this.searchReceiptId.length && !this.searchCampaignId.length) {
        this.getRecentReceipts({ userToken: this.userToken }).then(data => {
          if (data.recentReceipts.length > 0) {
            this.page += 1;
            console.log(">>>",data)
            this.recentReceipts = data.recentReceipts;
          }
          this.isLoading = false;
        });
        return;
      }

      let lastReceiptId = false;
      if (this.recentReceipts[this.recentReceipts.length - 1]) {
        lastReceiptId = this.recentReceipts[this.recentReceipts.length - 1]
          .id;
      }
      const payload = this.makePayload();
      this.isLoading = true;
      this.searchReceipt(payload).then(result => {
        this.recentReceipts = result.receipts;
        this.isLoading = false;
      });
    },
    paginatedSearch($state) {
      let lastReceiptId = false;
      if (this.recentReceipts[this.recentReceipts.length - 1]) {
        lastReceiptId = this.recentReceipts[this.recentReceipts.length - 1].id;
      }

      const payload = this.makePayload();
      payload.lastId = lastReceiptId;

      console.log("paginatedSearch", payload);
      this.isLoading = true;
      this.searchReceipt(payload).then(result => {
        if (result.receipts.length > 0) {
          this.recentReceipts = [...this.recentReceipts, ...result.receipts];
          this.isLoading = false;
          $state.loaded();
        } else {
          this.isLoading = false;
          $state.complete();
        }
      });
    },

    loadRecentReceipts($state) {
      let lastReceiptId = false;
      if (this.recentReceipts[this.recentReceipts.length - 1]) {
        lastReceiptId = this.recentReceipts[this.recentReceipts.length - 1]
          .id;
      }

      const payload = { userToken: this.userToken, limit: 30, dashboard:this.selectedDashboard };
      lastReceiptId ? (payload["lastId"] = lastReceiptId) : null;
      this.isLoading = true;

      this.getRecentReceipts(payload).then(data => {
        if (data.recentReceipts.length > 0) {
          if(this.recentReceipts.length && this.recentReceipts[this.recentReceipts.length-1].id === data.recentReceipts[data.recentReceipts.length-1].id ){
            return $state.complete();
          }
          this.page += 1;

          this.recentReceipts = [
            ...this.recentReceipts,
            ...data.recentReceipts
          ];
          this.isLoading = false;
          $state.loaded();
        } else {
          this.isLoading = false;
          $state.complete();
        }
      });
    },
    infiniteHandler($state) {
      this.infiniteState = $state;
      if (
        this.searchReceiptId.length ||
        this.searchCampaignId.length ||
        this.searchDashboarderId.length
      ) {
        return this.paginatedSearch($state);
      }
      this.loadRecentReceipts($state);
    },
    formattedDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    ...mapActions([
      "getRecentReceipts",
      "searchReceipt",
      "getAnyReceiptWithId",
      "getDashboardData",
      "getProductsList",
      "getReceiptwithRefNumber"
    ]),
    setCurrentReceipt(item, campaign) {
      this.$refs.inspectMode=false;
      this.getReceiptwithRefNumber({
        userToken: this.userToken,
        referenceNumber: item.referenceNumber,
        dashboard: this.selectedDashboard
      }).then(res => {
        const receipt = res.receipt;

        const products = res.campaignProducts;
        if (this.selectedDashboard.isCroppable) {
          this.receiptImageURL = receipt.receiptFullImageURL;
        } else {
          this.receiptImageURL = receipt.receiptImageURL;
        }
        this.productImageURL = receipt.productImageURL;

        const payload = {
          userToken: this.userToken,
          dashboard: this.selectedDashboard,
          campaign_fk: receipt.campaign_fk
        };
        this.getDashboardData(payload);
        this.img = new Image();
        this.receiptImageIsLoading = true;
        this.img.onload = () => {
          this.paymentAmount = receipt.paymentAmount;
          this.receiptImageIsLoading = false;
          this.receiptImageElement = this.img;
        };

        this.img.src = this.receiptImageURL;
        this.createdAt = receipt.createdAt;
        this.campaignTitle = receipt.campaignTitle;
        this.campaign_fk = receipt.campaign_fk;
        this.receiptDateTime = receipt.receiptDateTime;
        this.createdAtTime = moment(receipt.updatedAt).format("HH:MM");
        this.createdAtDate = receipt.updatedAt;
        this.status = receipt.status;
        this.id = receipt.receiptToken;
        this.customerToken = receipt.customerToken;
        this.referenceNumber = receipt.referenceNumber;
        this.receiptNumber = receipt.identifiedId;
        this.total = receipt.total;
        this.postCode = receipt.postCode;
        this.receiptId = receipt.receiptId
        this.couponsToCreate = receipt.couponsPerReceipt;
        this.detailsText = receipt.detailsText;
        this.country = receipt.country;
        this.retailerFk =
          receipt.retailer == "15" ? "Not selected" : receipt.retailer;
        if (typeof this.retailerFk === "string") {
          this.retailerFk = parseInt(this.retailerFk);
        }
        this.campaign_fk = receipt.campaignId;
        this.rejectReason = receipt.rejectReason;
        this.paymentAmount = receipt.paymentAmount;
        if (receipt.clubCode) this.clubCode = receipt.clubCode;
        if (receipt.fiscalId) this.fiscalId = receipt.fiscalId;
        if (receipt.rppData) this.rppData = receipt.rppData;
        this.campaignEndDate = moment(receipt.campaignEndDate).format(
          "DD-MM-YYYY"
        );
        this.campaignStartDate = moment(receipt.campaignStartDate).format(
          "DD-MM-YYYY"
        );
        this.hasWallet = receipt.hasWallet;
        if (receipt.selectedProducts) {
          this.selectedProducts = JSON.parse(receipt.selectedProducts);
          console.log("PPPP", this.selectedProducts);
        }
        if (this.hasWallet) {
          const identifications = JSON.parse(receipt.identifications);

          if (identifications) this.productTotal = identifications.productTotal;
        }

        this.getProductsList({
          dashboard: this.selectedDashboard,
          campaignId: receipt.campaignId
        }).then(products => {
          console.log("PRODUCTS", products);
          if (products.length) {
            this.products = products;
            this.processedProducts = [];
            this.showDialog = true;
          } else if (this.selectedDashboard.campaignId === 'pg-ro') {
            this.products = products
            this.processedProducts = []
            this.showDialog = true
          }
        });

        if (this.couponsToCreate === -1) {
          this.hasEditableCoupons = true;
          this.couponsToCreate = 1;
        }
        this.campaignRetailers = res.campaignRetailers;

        if (receipt.hasWallet) {
          this.hasWallet = receipt.hasWallet;
        }
        console.log("PPP", receipt.selectedProducts);
        if (res.campaignProducts && res.campaignProducts.length) {
          this.products = res.campaignProducts;
          this.processedProducts = [];
          if (
            "processedProducts" in receipt &&
            receipt.processedProducts != null
          ) {
            const parsedSelecteds = JSON.parse(receipt.processedProducts);
            parsedSelecteds.forEach(selectedProduct => {
              console.log("SELECTEd PPP", selectedProduct);
              const product = {
                groupingId: selectedProduct.groupingId.split("$$")[1],
                items: selectedProduct.items,
                total: selectedProduct.total
              };
              this.processedProducts.push(product);
              const foundProduct = this.products.find(
                e => e.ean === product.groupingId
              );
              foundProduct.count = product.items;
            });
          }
        }
      });
    }
  },
  mounted(){
     if ("name" in this.selectedDashboard === false) {
      const dashboard = JSON.parse(localStorage.selectedDashboard);
      this.$store.commit("setDashboard", dashboard);
    }
    this.$store.commit("setUserRoles", JSON.parse(localStorage.userRoles));
  }
};
</script>
